<template>
    <BreadCrumb PageTitle="Task Type List" />
    <TaskTypeList />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import TaskTypeList from "../../components/TaskTypes/TaskTypeList.vue";
  
  export default defineComponent({
    name: "TaskTypesPage",
    components: {
      BreadCrumb,
      TaskTypeList,
    },
  });
  </script>